const upperCaseOptions = ['yes', 'no'];

function setContractName(el) {
  const text = el.textContent.trim();
  if (upperCaseOptions.includes(text.toLowerCase())) {
    el.textContent = text.toUpperCase();
  }
}

export default {
  mounted(el) {
    setContractName(el);
  },
  updated(el) {
    setContractName(el);
  },
};
